import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Spin } from 'antd';
import ReadOnlyDocumentList from '../../../../ReadOnlyDocumentList';

interface Tab4Props {
  form?: any;
  document?: any[];
  loading?: boolean;
}

function Tab4({ form, document = [], loading = false }: Tab4Props) {
  return (
    <div className='tabItem'>
      <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"} p={2}>
        <Typography variant="subtitle1" color="primary" gutterBottom>
          📄 Documents attachés à la demande
        </Typography>
        <Spin spinning={loading}>
          <ReadOnlyDocumentList documents={document} loading={loading} />
        </Spin>
      </Box>
    </div>
  );
}

export default Tab4;